import React, { FC } from 'react';
import { SelectField } from 'components/select-field/select-field';
import { getIn, useFormikContext } from 'formik';

import { NewCentralFormType } from '../types';

export enum SearchTextOperations {
  CONTAINS = 'CONTAINS',
  CAC = 'CONTAINS_AND_CONTAINS',
  MATCH_PHRASE = 'MATCH_PHRASE',
  EQ = 'EQ',
}

type Props = {
  disabled?: boolean;
  name: string;
  options?: { id: string; label: string }[];
  defaultOption?: SearchTextOperations;
};

const SelectTextOperation: FC<Props> = ({
  disabled,
  name,
  options,
  defaultOption = SearchTextOperations.CONTAINS,
}) => {
  const formikCtx = useFormikContext<NewCentralFormType>();
  const { setFieldValue, values } = formikCtx;
  return (
    <SelectField
      disabled={disabled}
      items={
        options ?? [
          { id: 'CONTAINS', label: 'Alespoň jedno slovo' },
          {
            id: 'CONTAINS_AND_CONTAINS',
            label: 'Všechna slova kdekoliv',
          },
          { id: 'MATCH_PHRASE', label: 'Přesná shoda (část fráze)' },
          { id: 'EQ', label: 'Přesná shoda (celá fráze)' },
        ]
      }
      value={getIn(values, name) ?? defaultOption}
      name={name}
      onChange={(id) => setFieldValue(name, id)}
      label="Operace"
    />
  );
};

export default SelectTextOperation;
